import React, {useEffect, useState} from "react";
import {useHistory} from "react-router";
import {Box, Button, Container, Grid, Link, TextField, Typography, useMediaQuery} from "@material-ui/core";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import Navigation from "../../../Components/Navigation/Navigation";
import {CopyToClipboard} from "react-copy-to-clipboard";
import Rating from "../../../Components/Rating";
import API from "../../../helpers/apiHelpers";
import {colorInputBorder} from "../../../Constants/theme";
import {useSnackbar} from "notistack";
import {RootState} from "../../../redux/store";
import {useSelector} from "react-redux";

interface GoogleReviewProps {
    rating?: number | undefined,
}

const useStyle = makeStyles({
    link: {
        textDecoration: "underline",
    },
    button: {
        maxWidth: 181,
    },
});

const links = {
    PA: "https://g.page/r/CWxzCTRMKMmUEAg/review",
    MI: "https://g.page/r/CZ57iNtytITUEAg/review",
    NJ: "https://g.page/r/CSetRTdU5gyFEAg/review",
};

const GoogleReview: React.FC<GoogleReviewProps> = () => {
    const classes = useStyle();
    const theme = useTheme();
    const history = useHistory();
    const {enqueueSnackbar} = useSnackbar();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [copied, setCopied] = useState(false);
    const [comment, setComment] = useState("");
    const [referralCode, setReferralCode] = useState("");
    const initialComment = useSelector((state: RootState) => state?.appointment.review.comments);
    const [url, setUrl] = useState("https://g.page/r/CSetRTdU5gyFEAg/review");
    const stateOfResidence = useSelector((state: RootState) => state?.userProfile.stateOfResidence);


    useEffect(() => {
        if (copied) {
            enqueueSnackbar("Copied!", {
                autoHideDuration: 4000
            });
            setCopied(false);
        }
    }, [copied]);

    useEffect(() => {

        (async () => {
            const getCode = await API.getReferralStats();
            setReferralCode(getCode.referralCode);
        })();
    }, []);

    useEffect(() => {
        if (initialComment) {
            setComment(initialComment);
        }
    }, [initialComment]);

    const goToReferrals = () => history.push("/referrals");

    useEffect(() => {
        if (Object.keys(links).includes(stateOfResidence)) {
            setUrl(links[stateOfResidence]);
        }
    }, [stateOfResidence]);

    return (
        <Container maxWidth="md">
            <Box marginTop="100px">
                <Grid container>
                    {!isMobile &&
                    <Grid item xs={3}>
                        <Navigation/>
                    </Grid>
                    }
                    <Grid item md={9} xs={12}>
                        <Container>
                            <>
                                <Box marginBottom="54px">
                                    <Typography variant="h2">
                                            We are so happy that you had a 5 paw experience!
                                    </Typography>
                                </Box>
                                <Box marginBottom="30px">
                                    <Rating initialValue={5}/>
                                </Box>
                                <Box marginBottom="24px">
                                    <Typography variant="h4">
                                            Help other pet parents learn about The Video Vets. Please review us on
                                            Google!
                                    </Typography>
                                </Box>
                                <Box marginBottom="44px">
                                    <TextField
                                        multiline
                                        rows={4}
                                        fullWidth
                                        variant="outlined"
                                        onChange={e => setComment(e.target.value)}
                                        value={comment}
                                    />
                                </Box>
                                <Box marginBottom="112px">
                                    <Button
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                    >
                                        <Link aria-label="submit Google review" href="https://g.page/r/CWxzCTRMKMmUEAg/review">
                                                Submit Review to Google
                                        </Link>
                                    </Button>
                                </Box>
                                <Box marginBottom="42px">
                                    <Typography variant="h2">
                                            Refer a friend to The Video Vets and receive $10 in appointment credit
                                    </Typography>
                                </Box>
                                <Box marginBottom="13px">
                                    <Typography variant="h4">
                                            Your invite code
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" marginBottom="37px">
                                    <Box marginRight="30px">
                                        <Typography style={{color: colorInputBorder}}>
                                            {referralCode}
                                        </Typography>
                                    </Box>
                                    <CopyToClipboard
                                        text={referralCode}
                                        onCopy={() => setCopied(true)}
                                    >
                                        <Button
                                            type="button"
                                            className={classes.button}
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={() => setCopied(true)}
                                        >
                                                Copy
                                        </Button>
                                    </CopyToClipboard>
                                </Box>
                                <Box marginBottom="20px">
                                    <Link aria-label="read more about how referrals work" href="#" onClick={goToReferrals} className={classes.link}>
                                        <Typography>
                                                Learn how referrals work here
                                        </Typography>
                                    </Link>
                                </Box>
                            </>
                        </Container>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};
export default GoogleReview;
